const FloatPlanStep = {
  CREATE: 1,
  SELECT_SHARE_CONTACT: 3,
  SELECT_EMERGENCY: 4,
};

export default FloatPlanStep;
